import VehicleBrandTypes from 'store/actionTypes/vehicleBrand'
import { vehicleBrandAPI } from 'store/api'
import { bindRequestLogic } from './utils'

const getVehicleBrands = bindRequestLogic({
  clientFunc: vehicleBrandAPI.getVehicleBrands,
  type: VehicleBrandTypes.GET_VEHICLE_BRANDS_REQUEST,
  successType: VehicleBrandTypes.GET_VEHICLE_BRANDS_SUCCESS,
  failType: VehicleBrandTypes.GET_VEHICLE_BRANDS_FAILED,
  isQueryParam: true
})

const getVehicleBrandDetail = bindRequestLogic({
  clientFunc: vehicleBrandAPI.getVehicleBrandDetail,
  type: VehicleBrandTypes.GET_VEHICLE_BRAND_DETAIL_REQUEST,
  successType: VehicleBrandTypes.GET_VEHICLE_BRAND_DETAIL_SUCCESS,
  failType: VehicleBrandTypes.GET_VEHICLE_BRAND_DETAIL_FAILED,
  modelName: 'vehicleBrand'
})

const addVehicleBrand = bindRequestLogic({
  clientFunc: vehicleBrandAPI.addVehicleBrand,
  type: VehicleBrandTypes.ADD_VEHICLE_BRAND_REQUEST,
  successType: VehicleBrandTypes.ADD_VEHICLE_BRAND_SUCCESS,
  failType: VehicleBrandTypes.ADD_VEHICLE_BRAND_FAILED
})

const updateVehicleBrand = bindRequestLogic({
  clientFunc: vehicleBrandAPI.updateVehicleBrand,
  type: VehicleBrandTypes.UPDATE_VEHICLE_BRAND_REQUEST,
  successType: VehicleBrandTypes.UPDATE_VEHICLE_BRAND_SUCCESS,
  failType: VehicleBrandTypes.UPDATE_VEHICLE_BRAND_FAILED
})

const deleteVehicleBrand = bindRequestLogic({
  clientFunc: vehicleBrandAPI.deleteVehicleBrand,
  type: VehicleBrandTypes.DELETE_VEHICLE_BRAND_REQUEST,
  successType: VehicleBrandTypes.DELETE_VEHICLE_BRAND_SUCCESS,
  failType: VehicleBrandTypes.DELETE_VEHICLE_BRAND_FAILED
})

// VEHICLE BRAND MESSAGE =====

const getVehicleBrandMessages = bindRequestLogic({
  clientFunc: vehicleBrandAPI.getVehicleBrandMessages,
  type: VehicleBrandTypes.GET_VEHICLE_BRAND_MESSAGES_REQUEST,
  successType: VehicleBrandTypes.GET_VEHICLE_BRAND_MESSAGES_SUCCESS,
  failType: VehicleBrandTypes.GET_VEHICLE_BRAND_MESSAGES_FAILED,
  isQueryParam: true
})

const addVehicleBrandMessage = bindRequestLogic({
  clientFunc: vehicleBrandAPI.addVehicleBrandMessage,
  type: VehicleBrandTypes.ADD_VEHICLE_BRAND_MESSAGE_REQUEST,
  successType: VehicleBrandTypes.ADD_VEHICLE_BRAND_MESSAGE_SUCCESS,
  failType: VehicleBrandTypes.ADD_VEHICLE_BRAND_MESSAGE_FAILED,
  isQueryParam: true
})

const updateVehicleBrandMessage = bindRequestLogic({
  clientFunc: vehicleBrandAPI.updateVehicleBrandMessage,
  type: VehicleBrandTypes.UPDATE_VEHICLE_BRAND_MESSAGE_REQUEST,
  successType: VehicleBrandTypes.UPDATE_VEHICLE_BRAND_MESSAGE_SUCCESS,
  failType: VehicleBrandTypes.UPDATE_VEHICLE_BRAND_MESSAGE_FAILED,
  isQueryParam: true
})

const deleteVehicleBrandMessage = bindRequestLogic({
  clientFunc: vehicleBrandAPI.deleteVehicleBrandMessage,
  type: VehicleBrandTypes.DELETE_VEHICLE_BRAND_MESSAGE_REQUEST,
  successType: VehicleBrandTypes.DELETE_VEHICLE_BRAND_MESSAGE_SUCCESS,
  failType: VehicleBrandTypes.DELETE_VEHICLE_BRAND_MESSAGE_FAILED
})

const getSystemVehicleBrands = bindRequestLogic({
  clientFunc: vehicleBrandAPI.getSystemVehicleBrands,
  type: VehicleBrandTypes.GET_SYSTEM_VEHICLE_BRANDS_REQUEST,
  successType: VehicleBrandTypes.GET_SYSTEM_VEHICLE_BRANDS_SUCCESS,
  failType: VehicleBrandTypes.GET_SYSTEM_VEHICLE_BRANDS_FAILED,
  isQueryParam: true
})

export default [
  getVehicleBrands,
  addVehicleBrand,
  updateVehicleBrand,
  deleteVehicleBrand,
  getVehicleBrandDetail,
  getVehicleBrandMessages,
  addVehicleBrandMessage,
  updateVehicleBrandMessage,
  deleteVehicleBrandMessage,
  getSystemVehicleBrands
]
